import { graphColors, MONTHS, pageColors } from "../../../util/constants";
import { siteMapping } from "../../../util/helperFunctions";



export const generateMonthlyUsageData = (statisticsData, selectedSite, stackView) => {
    const dataToPlot = [];

    if (statisticsData?.length > 0) {
        if (selectedSite?.length === 1 && !stackView) {
            const statisticX = statisticsData.map(item => 
                MONTHS[item.month] + " " + item.year
            );
            const statisticY = statisticsData.map(item => item.count);
            const width = statisticsData.map(() => 0.3);

            const trace = {
                type: "bar",
                x: statisticX,
                y: statisticY,
                width: width,
                marker: {
                    color: '#0097A9',
                },
            };
            dataToPlot.push(trace);
        } else {
            // Group data by month
            const groupedByMonth = statisticsData.reduce((acc, item) => {
                const monthKey = MONTHS[item.month];
                if (!acc[monthKey]) {
                    acc[monthKey] = [];
                }
                acc[monthKey].push(item);
                return acc;
            }, {});

            Object.entries(groupedByMonth).forEach(([month, items], index) => {
                const trace = {
                    type: "bar",
                    x: items.map(item => siteMapping(item.site)),
                    y: items.map(item => item.count),
                    width: items.map(() => 0.3),
                    name: month + " " + items[0].year,
                    marker: {
                        color: graphColors[index % graphColors.length],
                    },
                };
                dataToPlot.push(trace);
            });
        }
    }
    return dataToPlot;
};

export const generatePageUsageData = (sitePageData) => {
    const dataToPlot2 = [];

    if (sitePageData?.length > 0) {
        // Group data by page
        const groupedByPage = sitePageData.reduce((acc, item) => {
            if (!acc[item.page]) {
                acc[item.page] = [];
            }
            acc[item.page].push(item);
            return acc;
        }, {});

        // Create traces for each page
        Object.entries(groupedByPage).forEach(([page, items]) => {
            const trace = {
                type: "bar",
                x: items.map(item => siteMapping(item.site)),
                y: items.map(item => item.count),
                width: items.map(() => 0.3),
                name: page,
                marker: {
                    color: pageColors[page],
                },
            };
            dataToPlot2.push(trace);
        });
    }

    return dataToPlot2;
};


export const generateLayout = (selectedSite, stackView) => {
    return {
        xaxis: {
            title: {
                text: selectedSite?.length === 1
                    ? `${selectedSite[0].label} Monthly Usage`
                    : "Asset Monthly Usage",
            },
        },
        yaxis: {
            title: {
                text: "Application Views",
            },
        },
        autosize: true,
        barmode: selectedSite?.length > 1 && !stackView ? undefined : "stack",
    };
};

export const generatePageLayout = () => {
    return {
        barmode: "stack",
        autosize: true,
        yaxis: {
            title: {
                text: "No. of Views",
            },
        },
        xaxis: {
            title: {
                text: "Asset Page Usage",
            },
        },
    };
};